import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CautionGlyph = /*#__PURE__*/createElement("g", {
  id: "caution"
}, /*#__PURE__*/createElement("path", {
  d: "M45.6,59c0,2-1.6,3.6-3.7,3.6c-2,0-3.7-1.6-3.7-3.6c0-2,1.6-3.6,3.7-3.6C43.9,55.4,45.6,57,45.6,59"
}), /*#__PURE__*/createElement("path", {
  d: "M41.9,32c-2,0-3.7,1.6-3.7,3.6c0,0.2,0,0.3,0,0.5c0.7,5.2,1.4,10.4,2.2,15.6c0.2,1.7,2.7,1.7,2.9,0 c0.7-5.2,1.4-10.4,2.2-15.6c0-0.2,0-0.3,0-0.5C45.6,33.6,43.9,32,41.9,32"
}), /*#__PURE__*/createElement("path", {
  d: "M16.6,65.7c-0.1,0.1,0,0.2,0.1,0.2h50.3c0.1,0,0.2-0.1,0.1-0.2C58.8,51.1,50.4,36.5,42,21.8c-0.1-0.1-0.2-0.1-0.3,0 C33.4,36.5,25,51.1,16.6,65.7 M70.4,65.2c0.9,1.6-0.2,3.6-2.1,3.6H15.6c-1.9,0-3-2-2.1-3.6C22.2,49.9,31,34.6,39.8,19.3 c0.9-1.6,3.3-1.6,4.2,0C52.8,34.6,61.6,49.9,70.4,65.2"
}));
const Caution = createSvg({
  name: 'caution',
  path: CautionGlyph
});

export default Caution;
export { CautionGlyph };
